export const FILTER_HEADER_TRANSLATION_KEY = 'learn-dashboard-filter-header';
